function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yedkvyn2ua"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3704",
    style: {
      fill: "#dc3545"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 727",
    style: {
      clipPath: "url(#yedkvyn2ua)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25421",
    d: "M10.138 21.238a1.3 1.3 0 0 1-1.27-1.27V7.9h-.233a.613.613 0 0 1-.452-.184.62.62 0 0 1-.183-.45.608.608 0 0 1 .182-.451.62.62 0 0 1 .452-.18h3.344a.613.613 0 0 1 .182-.455.62.62 0 0 1 .454-.18h4.317a.623.623 0 0 1 .635.635h3.344a.613.613 0 0 1 .452.184.62.62 0 0 1 .182.455.608.608 0 0 1-.182.451.62.62 0 0 1-.452.18h-.233v12.063a1.3 1.3 0 0 1-1.27 1.27zm0-13.333v12.063h9.27V7.9zm2.243 9.608a.613.613 0 0 0 .184.452.62.62 0 0 0 .455.182.608.608 0 0 0 .451-.182.62.62 0 0 0 .18-.452v-7.174a.613.613 0 0 0-.184-.452.62.62 0 0 0-.455-.182.608.608 0 0 0-.451.182.62.62 0 0 0-.18.452zm3.513 0a.613.613 0 0 0 .184.452.62.62 0 0 0 .455.182.608.608 0 0 0 .451-.182.62.62 0 0 0 .18-.452v-7.174a.613.613 0 0 0-.184-.452.62.62 0 0 0-.455-.182.608.608 0 0 0-.451.182.62.62 0 0 0-.18.452zM10.138 7.9z",
    transform: "translate(-5.143 -3.143)",
    style: {
      fill: "#dc3545"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcn);
export default __webpack_public_path__ + "static/media/delete-icn.3dba2263f7bfb75b6d4990d4f26b2c13.svg";
export { ForwardRef as ReactComponent };